import BackgroundStyleGroup from './BackgroundStyleGroup';
import BackgroundGradient from './BackgroundGradient';
import LockableUnitInput from './LockableUnitInput';
import { LabeledUnitInput } from './UnitInput';
import RichTextEditor from '../RichTextEditor';
import DataAttributes from './DataAttributes';
import DraggableItems from './DraggableItems';
import FontSelection from './FontSelection';
import ImagePreview from './ImagePreview';
import SimpleMargin from './SimpleMargin';
import SimpleBorder from './SimpleBorder';
import SectionFrame from './SectionFrame';
import BorderRadius from './BorderRadius';
import PrependInput from './PrependInput';
import ColorPicker from './ColorPicker';
import WebhookHelp from './WebhookHelp';
import FontSpaceLH from './FontSpaceLH';
import ColumnSize from './ColumnSize';
import FormFields from './FormFields';
import CodeEditor from './CodeEditor';
import IconSelect from './IconSelect';
import UnitInput from './UnitInput';
import Mappable from './Mappable';
import Checkbox from './Checkbox';
import HelpText from './HelpText';
import Spacing from './Spacing';
import Border from './Border';
import Switch from './Switch';
import Select from './Select';
import Range from './Range';
import Input from './Input';
import Tabs from './Tabs';

// TODO: should load directly from resources
import GlobalSavedColors from './GlobalSavedColors';
import MigrateDynamicTextItems from './MigrateDynamicTextItems';

export default {
    // TODO: forgot it 🤦‍♂️
    GlobalSavedColors,
    MigrateDynamicTextItems,

    Input,
    Range,
    Select,
    Switch,
    Border,
    Spacing,
    Tab: Tabs,
    HelpText,
    Mappable,
    Checkbox,
    UnitInput,
    IconSelect,
    FormFields,
    CodeEditor,
    ColumnSize,
    ColorPicker,
    FontSpaceLH,
    WebhookHelp,
    SectionFrame,
    PrependInput,
    BorderRadius,
    FontSelection,
    SimpleBorder,
    SimpleMargin,
    ImagePreview,
    DataAttributes,
    RichTextEditor,
    DraggableItems,
    LabeledUnitInput,
    LockableUnitInput,
    BackgroundGradient,
    BackgroundStyleGroup,
};
